import { combineReducers } from 'redux';
import sessionReducer from './session.reducer';
import currentUserReducer from './currentUser.reducer';
import currentAccountReducer from './currentAccount.reducer';
import storeReducer from './store.reducer';
import eventReducer from './event.reducer';
import contactsReducer from './contacts.reducer';
import reportReducer from './report.reducer';
import authorizationReducer from './authorization.reducer';
import publicReducer from './public.reducer';
import dialerReducer from './dialer.reducer';
import otherReducer from './other.reducer';
import smsReducer from './sms.reducer';
import workflowReducer from './workflows.reducer';
import adminUsersReducer from './admin/users.reducer';
import adminCampaignPageSubscriptionsReducer from './admin/campaignPageSubscriptions.reducer';
import adminTrainingsReducer from './admin/trainings.reducer';
import adminSettingsReducer from './admin/settings.reducer';
import adminTransfersReducer from './admin/transfers.reducer';
import adminSmsReducer from './admin/sms.reducer';
import adminDialerReducer from './admin/dialer.reducer';
import adminApiTrackingReducer from './admin/api_tracking.reducer';
import adminApiRequestsReducer from './admin/api_requests.reducer';
import adminEmailValidationReportsReducer from './admin/email_validation_reports.reducer';
import adminAuthIpsReducer from './admin/auth_ips.reducer';
import adminWalletReducer from './admin/wallet.reducer';
import adminSubscriptionsReducer from './admin/subscriptions.reducer';
import customDomainsReducer from './customDomains.reducer';
import businessUnitsReducer from './businessUnits.reducer';
import walletReducer from './wallet.reducer';
import maxplusReducer from './maxplus.reducer';
import onboardingReducer from './onboarding.reducer';
import campaignPagesReducer from './campaignPages.reducer';
import { LOG_OUT } from '../actions/session.actions';

const appReducer = combineReducers({
  session: sessionReducer,
  currentUser: currentUserReducer,
  currentAccount: currentAccountReducer,
  customDomains: customDomainsReducer,
  businessUnits: businessUnitsReducer,
  store: storeReducer,
  event: eventReducer,
  contacts: contactsReducer,
  report: reportReducer,
  authorization: authorizationReducer,
  dialer: dialerReducer,
  public: publicReducer,
  other: otherReducer,
  sms: smsReducer,
  wallet: walletReducer,
  maxplus: maxplusReducer,
  onboarding: onboardingReducer,
  workflows: workflowReducer,
  campaignPages: campaignPagesReducer,
  admin: combineReducers({
    users: adminUsersReducer,
    trainings: adminTrainingsReducer,
    settings: adminSettingsReducer,
    transfers: adminTransfersReducer,
    dialer: adminDialerReducer,
    sms: adminSmsReducer,
    api_tracking: adminApiTrackingReducer,
    api_requests: adminApiRequestsReducer,
    email_validation_reports: adminEmailValidationReportsReducer,
    auth_ips: adminAuthIpsReducer,
    wallet: adminWalletReducer,
    subscriptions: adminSubscriptionsReducer,
    campaignPageSubscriptions: adminCampaignPageSubscriptionsReducer
  })
});

const rootReducer = (state, action) => {
  if (action.type === LOG_OUT) {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

export default rootReducer;
